function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { BehaviorSubject, Observable, timer } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { EmptyExchangeSymbolDataItem } from "./interfaces";
import { SymbolMap } from "./SymbolMap";
export var SymbolProviderProtocol = /*#__PURE__*/function () {
  function SymbolProviderProtocol(_cacheKey) {
    _classCallCheck(this, SymbolProviderProtocol);
    _defineProperty(this, "subject", new BehaviorSubject(EmptyExchangeSymbolDataItem));
    _defineProperty(this, "cacheKey", void 0);
    this.cacheKey = _cacheKey;
  }
  _createClass(SymbolProviderProtocol, [{
    key: "getCachedSymbolData",
    value: function getCachedSymbolData() {
      return this.subject.getValue();
    }
  }, {
    key: "init",
    value: function init() {
      return this.initWithCache();
    }
  }, {
    key: "register",
    value: function register() {
      var _this = this;
      return timer(0, 5 * 60 * 1000).pipe(exhaustMap(function () {
        return _this.updateAndCache();
      }));
    }
  }, {
    key: "getSymbolDataObservable",
    value: function getSymbolDataObservable() {
      var _this2 = this;
      return new Observable(function (subscriber) {
        var subscription = _this2.subject.subscribe(function (data) {
          subscriber.next(data);
        });
        subscriber.add(subscription.unsubscribe);
      });
    }
  }, {
    key: "getSymbol",
    value: function getSymbol(symbol) {
      return this.subject.getValue().map.get(symbol);
    }
  }, {
    key: "getSymbolDataItem",
    value: function getSymbolDataItem() {
      return this.subject.getValue();
    }
  }]);
  return SymbolProviderProtocol;
}();
var quoteSortList = ["USDT", "BTC", "ETH"];
export function sortQuotes(quotes) {
  quotes = quotes.slice();
  var result = [];
  quoteSortList.forEach(function (quote) {
    var index = quotes.indexOf(quote);
    if (index !== -1) {
      result.push(quote);
      quotes.splice(index, 1);
    }
  });
  if (quotes.length > 0) {
    result.push.apply(result, _toConsumableArray(quotes.sort()));
  }
  return result;
}
export function toSymbolData(symbolType, data) {
  var symbolMap = new SymbolMap();
  var quotes = [];
  data.forEach(function (symbol) {
    if (!symbol.baseDisplay) {
      symbol.baseDisplay = symbol.base;
    }
    symbolMap.set(symbol.symbol, symbol);
    if (quotes.indexOf(symbol.quote) === -1) {
      quotes.push(symbol.quote);
    }
  });
  return {
    symbolType: symbolType,
    symbols: data,
    map: symbolMap,
    quotes: sortQuotes(quotes)
  };
}